import { useCurrentShopContext } from '../../../../../../../hooks/useCurrentShopContext'
import { useDraftContext } from '../../../../../../../providers/DraftProvider'
import { useSectionSchemasQuery } from './useSectionSchemasQuery'

export const useSectionConfigurations = (blockType: string) => {
  const { currentShop } = useCurrentShopContext()
  const { draftId } = useDraftContext()

  const { sectionSchemasQuery } = useSectionSchemasQuery([
    { shop_id: currentShop.id, draft_theme_id: draftId },
    {
      platform_block_type: blockType,
    },
  ])

  return {
    sectionConfigurations: sectionSchemasQuery.data?.sectionSchemas,
  }
}
